// extracted by mini-css-extract-plugin
export default {"headingPostcode":"rJNFmSHj2z","heading":"oxM2pAyvPD"};